module.exports = __webpack_public_path__ + "static/media/dk4021.b8b61da2.png";